<template>
  <div id="laws-list">
    <div class="page-tabs">
      <el-form :model="search" ref="search" style="margin-top: 10px">
        <el-row>
          <el-col :span="8">
            <el-form-item prop="searchTitle">
              <el-input
                prefix-icon="el-icon-search"
                v-model="search.searchTitle"
                style="width: 100%"
                placeholder="请输入政策名称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="margin-left: 10px">
            <div>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="searchList"
                >查询
              </el-button>
              <el-button icon="el-icon-refresh-right" @click="handleClear()">
                重置刷新
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="laws-box" v-loading="loading">
        <div
          v-for="(item, index) in noticeList"
          :key="index"
          class="laws-li"
          @click="$router.push({ name: 'rtfPreview', params: item })"
        >
          <div class="laws-li-l">
            <div class="laws-li-img">
              <img src="../../assets/images/common/right-1.png" alt="" />
            </div>
            <span>{{ item.title }}</span>
          </div>
          <div class="laws-li-r">
            {{ item.createTime }}
          </div>
        </div>
        <div v-if="!noticeList.length" class="park-list-table-no-c">
          <div class="park-list-table-no-c-img">
            <img src="@/assets/images/common/1.png" alt="" />
          </div>
          <div class="park-list-table-no-c-span">
            抱歉，没有找到符合条件的结果
          </div>
        </div>
      </div>
    </div>

    <div class="page-box" v-show="noticeList.length">
      <el-pagination
        :current-page="search.current"
        :page-sizes="[10, 20, 40, 80]"
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="search.size"
        layout=" prev, pager, next,total, jumper "
        :total="total"
      ></el-pagination>
    </div>
    <tools></tools>
  </div>
</template>
<script>
import { getPolicyPage } from "@/api/setting/investment";
import Tools from "@/views/home/components/tools";
export default {
  name: "laws-list",
  components: { Tools },
  data() {
    return {
      activeName: "01",
      search: {
        searchTitle: "",
        size: 10,
        current: 1,
      },
      noticeList: [],
      total: 0,
      classifyList: [
        { value: "01", label: "法律法规", isShow: true },
        { value: "02", label: "中共中央、国务院文件", isShow: true },
        { value: "03", label: "部门规章", isShow: true },
        { value: "04", label: "部门规范性文件", isShow: true },
        { value: "05", label: "法律法规适用解释及复函", isShow: true },
        { value: "06", label: "行业动态", isShow: false },
        { value: "07", label: "市场动态", isShow: false },
        { value: "08", label: "宏观态势", isShow: false },
        { value: "09", label: "通知公告", isShow: false },
      ],
      loading: false,
    };
  },
  created() {
    window.addEventListener("keydown", this.handkeyCode, true); //开启监听键盘按下事件
  },
  mounted() {
    this.getNotice();
  },
  methods: {
    handleClick() {
      this.search.classify = this.activeName;
      this.search.current = 1;
      this.getNotice();
    },
    handkeyCode(e) {
      if (e.keyCode === 13) {
        this.getNotice();
      }
    },
    //切换页码
    handleCurrentChange(val) {
      this.search.current = val;
      this.getNotice();
    },
    searchList() {
      this.search.current = 1;
      this.getNotice();
    },
    // 清除搜索
    handleClear() {
      this.search.searchTitle = "";
      this.getNotice();
    },
    //切换页条数
    handleSizeChange(val) {
      this.search.size = val;
      this.getNotice();
    },
    //公告列表
    getNotice() {
      this.loading = true;
      getPolicyPage(this.search).then((res) => {
        if (res.data.success) {
          this.total = res.data.data.total;
          let data = res.data.data.records;
          data.forEach((item) => {
            item.createTime = item.createTime
              ? item.createTime.slice(0, 10)
              : "";
          });
          this.noticeList = data;
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style scoped>
#laws-list {
  /* min-height:calc(100% - 50px); */
  width: 60%;
  margin: 0 auto;
  background: white;
  /* min-height: calc(100% - 326px);
  height: auto;
  display: inline-table; */
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.page-tabs {
  min-height: calc(100% - 80px);
  padding: 0 10px;
}

.laws-li {
  padding: 10px;
  display: flex;
  font-size: 0.95rem;
  font-weight: 600;
  /* width: 100%; */
  cursor: pointer;
  justify-content: space-between;
}

.laws-li-img {
  padding-right: 10px;
}

.laws-li:hover {
  border: 1px solid #eee;
  box-shadow: 0 0 10px #d3d2d2;
}

.laws-li:active {
  background-color: #00000010;
}

.laws-li-l {
  width: calc(100% - 220px);
  display: flex;
}

.laws-li-l > span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.laws-li-r {
  width: 200px;
  text-align: right;
  color: #b9b9b9;
}

.page-box {
  margin: 20px 0;
  display: flex;
  justify-content: center;
}

::v-deep .page-box .el-pager li {
  border: 1px solid #409eff;
}

::v-deep .el-pagination button:disabled {
  color: #fff;
  background: #409eff;
}

::v-deep .el-pagination .btn-prev {
  margin: 0 10px;
  padding-right: 8px;
}

::v-deep .el-pagination .btn-next {
  padding-left: 8px;
  margin: 0 10px;
}

::v-deep .el-pager li {
  padding: 0;
  margin: 0 4px;
}

::v-deep .el-tabs__item {
  font-size: 1rem;
}

.park-list-table-no-c {
  width: 300px;
  margin: 100px auto 50px;
}

.park-list-table-no-c-img {
  width: 100%;
}

.park-list-table-no-c-img > img {
  width: 100%;
}

.park-list-table-no-c-span {
  margin: 0 auto;
  width: 50%;
  text-align: center;
  font-size: 0.75rem;
  color: #c7c3c3;
}
</style>
